import { render } from "./NewRequisitionModal.vue?vue&type=template&id=6f4ae533&scoped=true"
import script from "./NewRequisitionModal.vue?vue&type=script&lang=js"
export * from "./NewRequisitionModal.vue?vue&type=script&lang=js"

import "./NewRequisitionModal.vue?vue&type=style&index=0&id=6f4ae533&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4ae533"]])

export default __exports__